/**
 * 三包登记的新增页面 货品配置处理
 * @author zjs
 * @time 2017-09-18
 */
let vm = {
    isTriggerFunc: true, // 标识是否触发func配置的调用
    data () {
        return {
            productConfig: [{
                prop: 'product',
                label: '货品编码',
                width: 260,
                json: {
                    size: 'small',
                    api: 'api/product',
                    prop: 'product_cai'
                },
                component: 'LyAutoProduct'
            }, {
                prop: 'product',
                label: '货品名称',
                width: 306,
                json: {
                    size: 'small',
                    api: 'api/product',
                    prop: 'product_name'
                },
                component: 'LyAutoProduct'
            }, {
                prop: 'quantity',
                label: '数量',
                width: 100,
                component: 'LyInputNumber'
            }, {
                prop: 'price',
                label: '本单售价',
                width: 100,
                component: 'LyInputNumber'
            }, {
                prop: 'xiaoji',
                label: '小计',
                width: 90,
                component: 'LyText'
            }, {
                prop: 'comment',
                label: '备注',
                width: 240,
                component: 'ElInput'
            }]
        }
    }
}
export default vm